import type { FinanceProvider } from "@kanda-libs/ks-frontend-services";

export const MODAL_ID = "edit-lender-config-modal";

// All finance providers that can be configured on a company.
export const FINANCE_PROVIDERS: FinanceProvider[] = [
  "allium",
  "demo",
  "etika",
  "humm",
  "humm_re",
  "novuna",
  "omni",
  "omni_re",
  "omni_lv",
  "propensio",
];
